import React, { PropTypes } from 'react';

import { NitroDefinition, NitroDivider } from 'nitro-components';

import moment from 'moment';

import { ALLOCATION_INFO_DRIVER, ALLOCATION_INFO_ALLOCATION_PERIOD } from '../content';

const PastDrivers = ({ list }) => {
  return (
    <div>
      {list.map((item, index) => {
        const startDate = moment(item.StartDate, 'DD/MM/YYYY').format('Do MMM YYYY').toString();
        const endDate = moment(item.EndDate, 'DD/MM/YYYY').format('Do MMM YYYY').toString();
        
        let driverInfo = [
          {
            title: ALLOCATION_INFO_DRIVER,
            description: `${item.DriverFirstName} ${item.DriverSurname}`
          },
          {
            title: ALLOCATION_INFO_ALLOCATION_PERIOD,
            description: `${startDate} ` + (item.EndDate!==null && item.EndDate!==""?"-"+endDate:"")
          }
        ];
        return (
          <div key={item.LeaseId}>
            <NitroDefinition data={driverInfo} />
            <NitroDivider />
          </div>
        );
      })}
    </div>
  );
};

PastDrivers.propTypes = {
  list: PropTypes.array
};

export default PastDrivers;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/PastDrivers.js